import { useState, useMemo } from 'react'

function usePagination(items, options = {}) {
  const { itemsPerPage = 10, initialPage = 1 } = options
  const [page, setPage] = useState(initialPage)

  const pageCount = Math.ceil(items.length / itemsPerPage)
  const paginatedItems = useMemo(
    () => items.slice((page - 1) * itemsPerPage, page * itemsPerPage),
    [items, page, itemsPerPage],
  )

  const onPageChange = page => {
    const MIN = 1
    const MAX = pageCount
    const newValue = Math.max(MIN, Math.min(MAX, page))
    setPage(newValue)
  }

  const onResetPage = () => {
    setPage(1)
  }

  return {
    page,
    pageCount,
    paginatedItems,
    onPageChange,
    onResetPage,
    totalItems: items.length,
    startIndex: (page - 1) * itemsPerPage + 1,
    endIndex: Math.min(page * itemsPerPage, items.length),
  }
}

export default usePagination
